import React from 'react'
import PropTypes from 'prop-types'
import { m } from 'framer-motion'
import { useLanguage } from '../../Context/LanguageContext'

const APP_STORE_URL = 'https://apps.apple.com/us/app/imigo-connect/id6744267446'
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=app.imigo'

const InstallAppCTA = ({
  title,
  description,
  variant = 'default',
  className = '',
}) => {
  const { t } = useLanguage()

  const resolvedTitle = title || t('appCta.title')
  const resolvedDescription = description || t('appCta.description')

  const variants = {
    default: 'bg-gradient-to-br from-fastblue via-darkslateblue to-darkpurple2 text-white',
    subtle: 'bg-lightgray text-darkgray border border-gray-200',
    inline: 'bg-white border border-gray-200 text-darkgray shadow-sm',
  }

  const buttonClass =
    variant === 'subtle' || variant === 'inline'
      ? 'bg-darkgray text-white hover:bg-gray-800'
      : 'bg-white text-darkgray hover:bg-gray-100'

  return (
    <m.div
      className={`install-app-cta rounded-2xl p-8 text-center ${variants[variant] || variants.default} ${className}`}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      <div className="max-w-2xl mx-auto">
        <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-neonorange/20 text-neonorange mb-4">
          <i className="fas fa-mobile-alt text-xl" aria-hidden="true"></i>
        </span>
        <h3 className="text-2xl font-bold mb-3">{resolvedTitle}</h3>
        <p className="mb-6 opacity-90 leading-relaxed">{resolvedDescription}</p>
        <div className="flex flex-wrap justify-center gap-3">
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={`inline-flex items-center gap-2 px-5 py-3 rounded-xl font-semibold transition-colors ${buttonClass}`}
          >
            <i className="fab fa-apple text-lg" aria-hidden="true"></i>
            {t('common.iosApp')}
          </a>
          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={`inline-flex items-center gap-2 px-5 py-3 rounded-xl font-semibold transition-colors ${buttonClass}`}
          >
            <i className="fab fa-google-play text-lg" aria-hidden="true"></i>
            {t('common.androidApp')}
          </a>
        </div>
        <p className="mt-4 text-sm opacity-75">{t('appCta.note')}</p>
      </div>
    </m.div>
  )
}

InstallAppCTA.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'subtle', 'inline']),
  className: PropTypes.string,
}

export { APP_STORE_URL, PLAY_STORE_URL }
export default InstallAppCTA
